module.exports = __webpack_public_path__ + "static/media/S (80).396a1501.jpg";